module.exports = __webpack_public_path__ + "img/redness_3.794d7c49.png";